import {
  FaUserPlus,
  FaFileUpload,
  FaUserCheck,
  FaBriefcaseMedical,
} from "react-icons/fa";

const steps = [
  {
    icon: <FaUserPlus />,
    title: "Register",
    description:
      "Create your professional or facility account in just a few minutes.",
  },
  {
    icon: <FaFileUpload />,
    title: "Upload Credentials",
    description:
      "Submit your licences, certifications and required documents securely.",
  },
  {
    icon: <FaUserCheck />,
    title: "Get Verified",
    description:
      "Our team reviews your information to ensure compliance and quality.",
  },
  {
    icon: <FaBriefcaseMedical />,
    title: "Start Working",
    description:
      "Apply for assignments or request qualified healthcare professionals.",
  },
];

function HowItWorks() {
  return (
    <section className="how-section">
      <div className="how-container">
        <div className="how-heading">
          <p className="section-label">How it works</p>
          <h2>Your journey with Zeth Health</h2>
          <p>
            Whether you're a healthcare professional looking for opportunities
            or a facility seeking reliable staff, getting started is simple.
          </p>
        </div>

        <div className="how-grid">
          {steps.map((step, index) => (
            <article className="how-card" key={step.title}>
              <div className="step-number">0{index + 1}</div>

              <div className="how-icon">{step.icon}</div>

              <h3>{step.title}</h3>

              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;